import { useRouteError } from "react-router-dom";
import { RotateCcw, TriangleAlert } from "lucide-react";

import { Button } from "src/components/ui/button";

const Error = () => {
	const error = useRouteError() as { message?: string; statusText?: string } | undefined;
	const message = error?.message ?? error?.statusText;

	return (
		<div className="tw-flex tw-min-h-dvh tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-bg-bg tw-px-6 tw-text-center">
			<div className="tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-red-tint tw-text-red">
				<TriangleAlert className="tw-h-6 tw-w-6" />
			</div>
			<div>
				<h1 className="tw-mb-1 tw-text-[20px] tw-font-bold tw-text-text">Something went wrong</h1>
				<p className="tw-max-w-md tw-text-[13.5px] tw-text-text-soft">
					An unexpected error occurred. Try reloading the page — if it keeps happening, please contact support.
				</p>
			</div>
			{message && (
				<pre className="tw-max-w-full tw-overflow-x-auto tw-rounded-lg tw-border tw-border-border tw-bg-white tw-px-3 tw-py-2 tw-text-left tw-text-[12px] tw-text-text-soft">
					{message}
				</pre>
			)}
			<Button size="sm" className="tw-gap-1.5 tw-bg-teal tw-text-white hover:tw-bg-teal-dark" onClick={() => window.location.reload()}>
				<RotateCcw className="tw-h-4 tw-w-4" />
				Reload page
			</Button>
		</div>
	);
};

export default Error;
